import "./ArchiveProductTemplate.module.css"
import Header from "@/reusable_sections/Header"
import ArchiveTitleSectionSection from "./sections/ArchiveTitleSectionSection"
import Listings from "./sections/Listings"
import Footer from "@/reusable_sections/Footer"

export default function ArchiveProductTemplatePage() {

  return (
    <div>
      <Header />
      <ArchiveTitleSectionSection />
      <Listings />
      <Footer />
    </div>
  )
}
